import React, {useState, useEffect, useCallback} from 'react';
import LawCompanyWithImage from './LawCompanyWithImage';
import LawCompanyAdvertise from "./LawCompanyAdvertise";
import api from '../api';

const VariousCompanyCards = React.memo(({ lawCompanies, onShowPopup, region }) => {
    const [advertise, setAdvertise] = useState(null);
    const [loading, setLoading] = useState(true);
    const companiesPerPage = 7;

    useEffect(() => {
        const fetchAdvertise = async () => {
            setLoading(true);
            try {
                let url = '/advertise/';
                if (region) {
                    url = `/advertise/?region=${region}`;
                }
                const response = await api.get(url);
                setAdvertise(response.data);
            } catch (error) {
                console.error('Error fetching the advertise data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchAdvertise();
    }, [region]);

    const getPaginatedCompanies = useCallback(() => {
        const paginatedCompanies = [];
        for (let i = 0; i < lawCompanies.length; i += companiesPerPage) {
            paginatedCompanies.push(lawCompanies.slice(i, i + companiesPerPage));
        }
        return paginatedCompanies;
    }, [lawCompanies]);

    const paginatedCompanies = getPaginatedCompanies();

    return (
        <>
            {paginatedCompanies.map((page, pageIndex) => (
                <React.Fragment key={pageIndex}>
                    {page.map(company => {
                        const hasActivePlans = company.active_plans && company.active_plans.length > 0;
                        const styleClass = hasActivePlans
                            ? 'vendor-day'
                            : (Math.random() > 0.5 ? 'vendor-verified' : '');

                        return (
                            <LawCompanyWithImage
                                key={company.id}
                                company={company}
                                onShowPopup={onShowPopup}
                                styleClass={styleClass}
                            />
                        );
                    })}

                    {!loading && advertise &&
                        <LawCompanyAdvertise
                            key={`ad-${pageIndex}`}
                            advertise={advertise}
                            region={region}
                        />
                    }
                </React.Fragment>
            ))}
        </>
    );
});

export default VariousCompanyCards;
